import { Icon } from '@components';

import theme from '../../../../themes/colors';

interface NameLengthWarningProps {
  show: boolean;
  message: string;
}

const NameLengthWarning = ({ show, message }: NameLengthWarningProps) => {
  if (!show) return null;

  return (
    <div className="absolute left-0 top-full flex items-center gap-1 text-xs text-cofeeOrange6">
      <Icon
        name="alert-circle"
        stroke={theme.cofeeOrange6}
        size="none"
        className="size-3.25 shrink-0"
      />
      <span>{message}</span>
    </div>
  );
};

export default NameLengthWarning;
